//ts-nocheck
import { createDirectus, graphql, staticToken } from "@directus/sdk"

const directusGraphQLServer = createDirectus(
  process.env.DIRECTUS_PUBLIC_URL || ""
)
  .with(staticToken(process.env.DIRECTUS_AUTH_HEADER || ""))
  .with(graphql())

export default directusGraphQLServer
